import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, defer, map, of } from 'rxjs';

import { MailOrderProfileEnrollmentService } from '@shared/services';
import { AuthService, TokenService } from '@core/services';

export const MailOrderAccessGuard: CanActivateFn = () => {
  // Inject services
  const authService = inject(AuthService);
  const mailOrderService = inject(MailOrderProfileEnrollmentService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  try {
    return defer(() => {
      if (authService.isAuthorizedByAzureB2c || authService.isAuthorizedBySSO) {
        const clientId = tokenService.getClientIdFromToken();
        return mailOrderService.suppressMailOrderProfileByClientId(clientId).pipe(
          map((disable) => {
            if (disable) {
              router.navigate(['/main']);
            }
            return disable ? false : true;
          }),
          catchError(() => {
            return of(true);
          })
        );
      } else {
        authService.logout();
        return of(false);
      }
    });
  } catch (error) {
    return of(true);
  }
};
